import * as yup from 'yup';
import { t } from 'i18next';
import type { IValidationField } from '../types';

export default function startDate({ label = '' }: IValidationField) {
  return yup
    .string()
    .label(label)
    .required()
    .default('')
    .isValidDate(t('errors.isInvalidDate', { label }))
    .isFutureDate(t('errors.isInvalidDate', { label }));
}
